import { actionTypes } from '../actionTypes/actionTypes';

export const updateSubscription = ( payload:any ) => ({
    type: actionTypes.updateSubscription,
    payload
});
